import Input from "@hudson/ui/components/FormFields/Input";
import Field from "@hudson/ui/components/FormFields/Field";

function Cvv({
  className = "",
  errorMessage,
  fieldName,
  label,
  requiredPlaceholder,
  value,
}: {
  className?: string;
  errorMessage: string;
  fieldName: string;
  label: string;
  requiredPlaceholder?: string;
  value?: string;
}): JSX.Element | null {
  return (
    <Field
      className={className}
      defaultValue={value}
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, onBlur) => (
        <Input
          autoComplete="cc-csc"
          className="w-24"
          inError={inError}
          onBlur={onBlur}
          onChange={onChange}
          required={Boolean(errorMessage)}
          requiredPlaceholder={requiredPlaceholder}
          value={value ? String(value) : ""}
        />
      )}
      fieldName={fieldName}
      fieldValidations={{ required: errorMessage }}
      label={label}
    />
  );
}

export default Cvv;
